/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label[_ngcontent-%COMP%]{text-transform:uppercase}.ui.input[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{max-width:400px}h5[_ngcontent-%COMP%]{margin:0;color:red}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:130px}.error[_ngcontent-%COMP%]{color:red}"];
export { styles as styles };
